<template>
  <div class="search-bar">
    <b-input
      class="search-input"
      :value="SearchInput"
      @change="searchHandle($event)"
      placeholder="請輸入股票代號或公司名稱( 預設顯示 2330 台積電 )"
    ></b-input>
    <b-button class="search-button" variant="primary" @click="blurSearch"
      >搜尋
    </b-button>
    <div>
      <ul class="search-dropdown" v-if="blurResponseList.length > 0">
        <template v-if="isInputCompanyName">
          <li
            v-for="(company, index) in blurResponseList"
            :key="index"
            @click="selectedHandle(company)"
          >
            {{ company.company_name }}
          </li>
        </template>
        <template v-else>
          <li
            v-for="(company, index) in blurResponseList"
            :key="index"
            @click="selectedHandle(company)"
          >
            {{ company.stock_symbol }}
          </li>
        </template>
      </ul>
      <ul class="search-dropdown" v-if="!hasResponseList">
        <li>查無資料</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      blurResponseList: [],
      SearchInput: "",
      isInputCompanyName: false,
      hasResponseList: true
    };
  },
  methods: {
    searchHandle(event) {
      if (event === "") return;
      if (!Number.isNaN(Number(event))) {
        //input 是股票代號
        this.isInputCompanyName = false;
        this.SearchInput = event;
        this.blurSearch();
      } else {
        //input 是公司名稱
        this.isInputCompanyName = true;
        this.SearchInput = event;
        this.blurSearch();
      }
    },
    selectedHandle(company) {
      if (this.isInputCompanyName) {
        //把公司名稱寫回 input
        this.SearchInput = company.company_name;
      } else {
        //把股票代號寫回 input
        this.SearchInput = company.stock_symbol;
      }
      this.blurResponseList = [];
      this.$store.commit("inputValueOfStockSymbol", company.stock_symbol);
      this.$router.push(
        `/stock/${this.$store.getters.outputOfStockSymbol}/report-year`
      );
    },
    blurSearch() {
      if (this.SearchInput === "") return;
      this.$store.dispatch("fetchCompanys", this.SearchInput).then(res => {
        if (res.length === 0) this.hasResponseList = false;
        else this.hasResponseList = true;
        this.blurResponseList = [...res];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$inputWidth: 400px;
.search-bar {
  max-width: 500px;
  margin: auto;
  padding: 20px;
  .search-input {
    display: inline-block;
    max-width: $inputWidth;
    vertical-align: middle;
  }
  .search-button {
    display: inline-block;
  }
  .search-dropdown {
    position: absolute;
    min-width: $inputWidth;
    max-width: $inputWidth;
    max-height: 134px;
    overflow: auto;
    z-index: 1;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    li {
      padding-bottom: 4px;
      cursor: pointer;
    }
  }
}
</style>
